var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711L6.41421 17H34C40.0751 17 45 21.9249 45 28V34C45 40.0751 40.0751 45 34 45H4C3.44772 45 3 44.5523 3 44C3 43.4477 3.44772 43 4 43H34C38.9706 43 43 38.9706 43 34V28C43 23.0294 38.9706 19 34 19H6.41421L16.7071 29.2929C17.0976 29.6834 17.0976 30.3166 16.7071 30.7071C16.3166 31.0976 15.6834 31.0976 15.2929 30.7071L3.29289 18.7071C2.90237 18.3166 2.90237 17.6834 3.29289 17.2929L15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackNv);
export default __webpack_public_path__ + "static/media/Back_nv.c8d5db687effb58c9d38470296bbcb54.svg";
export { ForwardRef as ReactComponent };